<template>
    <div class="workOwnershipInformation">
        <div class="typeContainer">
            <div class="listTitle" style="margin-top: 0">
                <span>*</span>著作权获得方式
            </div>
            <div class="typelist">
                <div v-for="(item, index) in copyrightList" :key="index"
                    :class="item.type == form.copyrightRightsGet ? 'active' : ''" @click="copyrightListClick(item)">
                    {{ item.name }}
                </div>
                <div style="width: 102px; height: 0"></div>
            </div>
            <div class="el-form-item__error" v-if="typeof form.copyrightRightsGet != 'number'">
                请选择著作权获得方式
            </div>
            <div class="forImgWap">
                <div class="itemList" v-if="form.copyrightRightsGet == 0">
                    <div class="theTitle">作品权利保证书</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C3')" />
                        <img v-if="uploadShow.C3" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C3.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C3">
                        请上传作品权利保证书
                    </div>
                </div>

                <div class="itemList" v-if="form.copyrightRightsGet == 1">
                    <div class="theTitle">著作权转让证明</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C11')" />
                        <img v-if="uploadShow.C11" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C11.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C11">
                        请上传著作权转让证明
                    </div>
                </div>

                <div class="itemList" v-if="form.copyrightRightsGet == 2">
                    <div class="theTitle">继承证明，如遗嘱</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C12')" />
                        <img v-if="uploadShow.C12" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C12.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C12">
                        请上传继承证明
                    </div>
                </div>
                <div class="itemList" v-if="form.copyrightRightsGet == 3">
                    <div class="theTitle">承受协议</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C13')" />
                        <img v-if="uploadShow.C13" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C13.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C13">
                        请上传承受协议
                    </div>
                </div>

                <div class="itemList" v-if="form.copyrightRightsGet == 4">
                    <div class="theTitle">赠与合同</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C14')" />
                        <img v-if="uploadShow.C14" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C14.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C14">
                        请上传赠与合同
                    </div>
                </div>
            </div>
            <div class="introduce" v-if="form.copyrightRightsGet != 5">
                请上传jpg、png、jepg、pdf、word格式，上传签章原件
            </div>
            <div class="listTitle"><span>*</span>权利产生方式</div>
            <div class="typelist">
                <div v-for="(item, index) in rightWayList" :key="index"
                    :class="item.type == form.copyrightProduceMode ? 'active' : ''" @click="rightWayListClick(item)">
                    {{ item.name }}
                </div>
                <div style="width: 102px; height: 0"></div>
            </div>
            <div class="el-form-item__error" v-if="typeof form.copyrightProduceMode != 'number'">
                请选择著作权获得方式
            </div>
            <div class="forImgWap">
                <div class="itemList" v-if="form.copyrightProduceMode == 2">
                    <div class="theTitle">法人创作协议</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C4')" />
                        <img v-if="uploadShow.C4" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C4.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C4">
                        请上传法人创作协议
                    </div>
                    <div class="downloadTemplate" @click="dowmloadMth('C4')">
                        下载模板（仅供参考）
                    </div>
                </div>
                <div class="itemList" v-if="form.copyrightProduceMode == 3">
                    <div class="theTitle">职务创作协议</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C5')" />
                        <img v-if="uploadShow.C5" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C5.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C5">
                        请上传职务创作协议
                    </div>
                </div>
                <div class="itemList" v-if="form.copyrightProduceMode == 1">
                    <div class="theTitle">合作创作协议</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C6')" />
                        <img v-if="uploadShow.C6" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C6.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C6">
                        请上传合作创作协议
                    </div>
                </div>
                <div class="itemList" v-if="form.copyrightProduceMode == 4">
                    <div class="theTitle">委托创作协议</div>
                    <div class="theImg">
                        <input type="file" @change="uploadFilePath($event, 'C7')" />
                        <img v-if="uploadShow.C7" src="@/assets/images/uploadOk.jpg" />
                        <img v-else src="@/assets/images/C7.png" />
                    </div>
                    <div class="el-form-item__error" v-if="!uploadShow.C7">
                        请上传委托创作协议
                    </div>
                    <div class="downloadTemplate" @click="dowmloadMth('C7')">
                        下载模板（仅供参考）
                    </div>
                </div>
            </div>
            <div class="introduce" v-if="form.copyrightProduceMode != 0">
                请上传jpg、png、jepg、pdf、word格式，上传签章原件
            </div>
            <div class="listTitle"><span>*</span>著作权人</div>
            <div class="successfulData" v-for="(item, index) in form.authorlist" :key="index">
                <div class="item" v-if="item.copyrightProduceMode">
                    <div class="title_">主体类型</div>
                    <div class="bodyNotBg">
                        <!-- {{ item.copyrightProduceMode == 1 ? "个人" : "企业" }} -->
                        {{
                                item.copyrightProduceMode == 0
                                    ? "个人"
                                    : item.copyrightProduceMode == 1
                                        ? "合作"
                                        : item.copyrightProduceMode == 2
                                            ? "法人"
                                            : item.copyrightProduceMode == 3
                                                ? "职务"
                                                : item.copyrightProduceMode == 4
                                                    ? "委托"
                                                    : item.copyrightProduceMode
                        }}
                    </div>
                </div>
                <div class="item" v-if="item.cardType">
                    <div class="title_">证件类型</div>
                    <div class="bodyBg">
                        <div>
                            {{
                                    item.cardType == 1
                                        ? "居民身份证"
                                        : item.cardType == 3
                                            ? "营业执照"
                                            : item.cardType == 4
                                                ? "居住证"
                                                : item.cardType == 9
                                                    ? "护照"
                                                    : item.cardType
                            }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.userName">
                    <div class="title_">姓名</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.userName }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.idNumber">
                    <div class="title_">证件号码</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.idNumber }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.sex">
                    <div class="title_">性别</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.sex == "1" ? "男" : "女" }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.ethnic">
                    <div class="title_">民族</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.ethnic }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.birthDate">
                    <div class="title_">出生日期</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.birthDate }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.address">
                    <div class="title_">证件地址</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.address }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.issueDate">
                    <div class="title_">证件签发日期</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.issueDate }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.expirationDate">
                    <div class="title_">证件失效日期</div>
                    <div class="bodyBg">
                        <div>
                            {{ item.expirationDate }}
                        </div>
                    </div>
                </div>
                <div class="item" v-if="item.cardHoldImage || item.cardBackImage || item.cardFrontImage">
                    <div class="title_">证件照片</div>
                    <div class="imgList">
                        <div>
                            <img :src="item.cardHoldImage" />
                        </div>
                        <div>
                            <img :src="item.cardBackImage" />
                        </div>
                        <div>
                            <img :src="item.cardFrontImage" />
                        </div>
                    </div>
                </div>
                <div class="pushAuthor" style="background: #cc3f1f" @click="articleDeleteAuthor(item)">
                    删除
                </div>
            </div>
            <div class="pushAuthor" v-if="!formShow" @click="pushRighMan()">
                添加著作权人
            </div>


            <div v-else>
                <personalform v-if="articleGetWorksInfoData.uplinkType == 1" @dataChange="dataChange" />
                <enterpriForm v-else @dataChange="dataChange" />
            </div>
            <div class="listTitle"><span>*</span>作者</div>
            <div class="authorList" v-for="(item, index) in form.authorlist" :key="index">
                <div class="key_">第 {{ index + 1 }} 位</div>
                <div class="valueSet">
                    <div class="txtStyle">
                        {{ item.userName }}
                    </div>
                    <div class="inputStyle">
                        <input type="text" v-model="item.name" placeholder="请输入作者署名、本名、别名、不具名…" />
                    </div>
                </div>
            </div>
            <div class="listTitle"><span>*</span>选择权利人</div>
            <div class="obligeeWap">
                <div class="name">权利人</div>
                <div class="obligeeList">
                    <div class="item" v-for="item in form.authorlist" :key="item"
                        @click="obligeeClick(item.uniqueCode)">
                        <div class="left_">
                            <img src="@/assets/images/radioIconActive.png" v-if="item.uniqueCode == obligee" />
                            <img src="@/assets/images/radioIcon.png" v-else />
                        </div>
                        <div class="right_">
                            {{ item.userName }}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="obligee">
                <div class="listTitle"><span>*</span>权力类别</div>
                <div class="rightListwap">
                    <div v-for="(item, index) in rightListdate" :key="index" @click="rightListMtn(index)"
                        :class="rightListdate[index].isTrue ? 'active' : ''">
                        {{ item.name }}
                    </div>
                    <div style="width: 114px; height: 0"></div>
                    <div style="width: 114px; height: 0"></div>
                    <div style="width: 114px; height: 0"></div>
                    <div style="width: 114px; height: 0"></div>
                    <div style="width: 114px; height: 0"></div>
                </div>
                <div class="el-form-item__error" v-if="!isArr">请选择权力类别</div>
            </div>

            <!-- <div class="listTitle"><span>*</span>证书选择</div>
            <div class="obligeeWap">
                <div class="obligeeList">
                    <div class="item" v-for="item in certificateList.list" :key="item"
                        @click="certificateClick(item.type)">
                        <div class="left_">
                            <img src="@/assets/images/radioIconActive.png" v-if="form.uplinkType == item.type" />
                            <img src="@/assets/images/radioIcon.png" v-else />
                        </div>
                        <div class="right_">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import personalform from '@/components/subjectinformation/personalForm.vue'
import enterpriForm from '@/components/subjectinformation/enterpriForm.vue'


import {
    articleGetWorksInfo,
    uploadFilePath,
    articleDeleteAuthor,
    articleUploadDETThree,
} from "../../api/interfaceList.js";

export default {
    name: "workOwnershipInformation",
    components: {
        personalform,
        enterpriForm
    },
    data() {
        return {
            formShow: false,
            articleGetWorksInfoData: '',
            obligee: "",
            obligeeType: 1,
            form: {
                copyrightProduceMode: 0,
                copyrightRightsGet: 0,
                authorlist: "",
                // uplinkType: 1,
                authorNameList: [
                    {
                        nameVlue: "",
                        name: "",
                    },
                ],
            },
            rightWayList: [
                {
                    name: "个人作品",
                    type: 0,
                },
                {
                    name: "合作作品",
                    type: 1,
                },
                {
                    name: "法人作品",
                    type: 2,
                },
                {
                    name: "职务作品",
                    type: 3,
                },
                {
                    name: "委托作品",
                    type: 4,
                },
            ],
            copyrightList: [
                {
                    name: "原创",
                    type: 0,
                },
                {
                    name: "转让",
                    type: 1,
                },
                {
                    name: "继承",
                    type: 2,
                },
                {
                    name: "承受",
                    type: 3,
                },
                {
                    name: "赠与",
                    type: 4,
                },
                {
                    name: "其他",
                    type: 5,
                },
            ],
            rightListdate: [
                {
                    name: "发表权",
                    type: 0,
                    isTrue: false,
                },
                {
                    name: "署名权",
                    type: 1,
                    isTrue: false,
                },
                {
                    name: "修改权",
                    type: 2,
                    isTrue: false,
                },
                {
                    name: "保护作品完整权",
                    type: 3,
                    isTrue: false,
                },
                {
                    name: "复制权",
                    type: 4,
                    isTrue: false,
                },
                {
                    name: "发行权",
                    type: 5,
                    isTrue: false,
                },
                {
                    name: "出租权",
                    type: 6,
                    isTrue: false,
                },
                {
                    name: "展览权",
                    type: 7,
                    isTrue: false,
                },
                {
                    name: "表演权",
                    type: 8,
                    isTrue: false,
                },
                {
                    name: "放映权",
                    type: 9,
                    isTrue: false,
                },
                {
                    name: "广播权",
                    type: 10,
                    isTrue: false,
                },
                {
                    name: "信息网络传播权",
                    type: 11,
                    isTrue: false,
                },
                {
                    name: "摄制权",
                    type: 12,
                    isTrue: false,
                },
                {
                    name: "改编权",
                    type: 13,
                    isTrue: false,
                },
                {
                    name: "翻译权",
                    type: 14,
                    isTrue: false,
                },
                {
                    name: "汇编权",
                    type: 15,
                    isTrue: false,
                },
                {
                    name: "其他",
                    type: 16,
                    isTrue: false,
                },
            ],
            certificateList: {
                list: [
                    {
                        name: "龙源版权确权平台证书",
                        type: 1,
                    },
                    {
                        name: "北京版权证书",
                        type: 2,
                    },
                    {
                        name: "北京版权证书+龙源版权确权平台证书",
                        type: 3,
                    },
                ],
            },
            filesData: new FormData(),
            contentUniqueCode: "",
            uploadShow: {
                C3: false,
                C11: false,
                C13: false,
                C12: false,
                C14: false,
                C4: false,
                C5: false,
                C6: false,
                C7: false,
            },
            isArr: false,
        };
    },
    mounted() {
        this.articleGetWorksInfo();
    },
    props: ["publicData"],
    computed: {
        personalType() {
            return this.publicData.personalType;
        },
    },
    watch: {
        personalType() {
            this.articleUploadDETThree();
        },
    },
    methods: {
        dataChange(e) {
            this.formShow = e.dataChangeShow
            e.data != '' ? this.form.authorlist.push(e.data) : ''
            // this.articleGetWorksInfo();
        },
        // certificateClick(e) {
        //     this.form.uplinkType = e;
        //     // this.certificateList.type = e
        // },
        obligeeClick(e) {
            this.obligee = e;
            this.rightListdate.map((i) => {
                i.isTrue = false;
            });
            this.form.authorlist.map((item) => {
                if (item.uniqueCode == e) {
                    this.rightListdate.map((itemss) => {
                        item.rightsCategoryArray.map((items) => {
                            if (itemss.type == items) {
                                itemss.isTrue = true;
                            }
                        });
                    });
                }
            });
        },
        articleUploadDETThree() {
            setTimeout(() => {
                let isOk = document.getElementsByClassName("el-form-item__error")[0];
                if (!isOk) {
                    let arr = [];
                    let json = [];
                    this.form.authorlist.map((item) => {
                        json = {
                            name: item.name,
                            rightsCategoryArray: item.rightsCategoryArray,
                            worksAuthorCode: item.uniqueCode,
                        };
                        arr.push(json);
                    });

                    let params = {
                        copyrightProduceMode: this.form.copyrightProduceMode,
                        copyrightRightsGet: this.form.copyrightRightsGet,
                        uniqueCode: this.contentUniqueCode,
                        worksAuthor: arr,
                        // uplinkType: this.form.uplinkType,
                    };
                    articleUploadDETThree(params).then((res) => {
                        if (res.code == 1) {
                            ElMessage({
                                message: res.message,
                                type: "success",
                            });
                            let json = {
                                key: 3,
                                isOk: true,
                            };
                            this.$emit("isOk", json);
                        } else {
                            ElMessage({
                                message: "参数错误或不完整",
                                type: "warning",
                            });
                        }
                    });
                } else {
                    setTimeout(() => {
                        document
                            .getElementsByClassName("el-form-item__error")[0]
                            .scrollIntoView({
                                behavior: "smooth", //带动画效果,平滑的滚动
                                block: "center",
                            });
                    }, 500);
                }
            }, 500);
        },
        articleDeleteAuthor(e) {
            let arr = []
            let index = 0
            this.form.authorlist.map(item => {
                arr.push(item.uniqueCode)
            })
            index = arr.indexOf(e.uniqueCode)

            articleDeleteAuthor({
                worksAuthorCode: e.uniqueCode,
            }).then((res) => {
                ElMessage({
                    message: res.message,
                    type: "success",
                });
                if (res.code == "1") {
                    this.form.authorlist.splice(index,1)
                    // this.articleGetWorksInfo();
                }
            });
        },
        uploadFilePath(e, type) {
            const loading = ElMessage({
                message: '上传中',
                type: 'warning',
                duration: 0
              })
            let files = e.target.files[0];
            this.filesData.append("files", files);
            let json = {
                files,
                fileType: type,
                worksCode: this.contentUniqueCode,
            };
            for (let key in json) {
                this.filesData.append(key, json[key]);
            }
            uploadFilePath(this.filesData).then((res) => {
                ElMessage({
                    message: res.message,
                    type: "success",
                });
                this.filesData = new FormData();
                if (res.code == 1) {
                    this.uploadOk = true;
                    if (type == "C3") {
                        this.uploadShow.C3 = true;
                    } else if (type == "C11") {
                        this.uploadShow.C11 = true;
                    } else if (type == "C13") {
                        this.uploadShow.C13 = true;
                    } else if (type == "C12") {
                        this.uploadShow.C12 = true;
                    } else if (type == "C14") {
                        this.uploadShow.C14 = true;
                    } else if (type == "C4") {
                        this.uploadShow.C4 = true;
                    } else if (type == "C5") {
                        this.uploadShow.C5 = true;
                    } else if (type == "C6") {
                        this.uploadShow.C6 = true;
                    } else if (type == "C7") {
                        this.uploadShow.C7 = true;
                    }
                }
            }).finally(() => {
                loading.close();
            });
        },
        dowmloadMth(type) {
            let href = `http://kb.qikan.cn/file/${type}.docx`;
            window.open(href, "_blank");
        },
        articleGetWorksInfo() {
            articleGetWorksInfo({
                contentUplinkCode: Cookies.get("uniqueCode"),
            }).then((res) => {
                res.data.worksAuthorList[0].postCode == 1 ? this.copyrightList[0].name = '原创' : this.copyrightList[0].name = '社创'
                this.articleGetWorksInfoData = res.data
                this.form.copyrightProduceMode = res.data.copyrightProduceMode;
                this.form.copyrightRightsGet = res.data.copyrightRightsGet;
                // this.form.uplinkType = res.data.uplinkType;
                this.uploadShow.C3 = res.data.worksFilesGroupDTOList.C3;
                this.uploadShow.C11 = res.data.worksFilesGroupDTOList.C11;
                this.uploadShow.C13 = res.data.worksFilesGroupDTOList.C13;
                this.uploadShow.C12 = res.data.worksFilesGroupDTOList.C12;
                this.uploadShow.C14 = res.data.worksFilesGroupDTOList.C14;
                this.uploadShow.C4 = res.data.worksFilesGroupDTOList.C4;
                this.uploadShow.C5 = res.data.worksFilesGroupDTOList.C5;
                this.uploadShow.C6 = res.data.worksFilesGroupDTOList.C6;
                this.uploadShow.C7 = res.data.worksFilesGroupDTOList.C7;
                res.data.worksAuthorList.map((item) => {
                    if (item.rightsCategoryArray) {
                        this.rightListdate.map((items) => {
                            item.rightsCategoryArray.map((itemss) => {
                                if (items.type == itemss) {
                                    items.isTrue = true;
                                }
                            });
                        });
                        this.isArr = true;
                    } else {
                        item.rightsCategoryArray = [];
                        this.isArr = false;
                    }
                });
                this.contentUniqueCode = res.data.uniqueCode;
                this.form.authorlist = res.data.worksAuthorList;
                this.obligee = res.data.worksAuthorList[0].uniqueCode;
            });
        },
        unique(arr) {
            return Array.from(new Set(arr));
        },
        rightListMtn(index) {
            this.rightListdate[index].isTrue = !this.rightListdate[index].isTrue;
            let arr = [];
            this.form.authorlist.map((item) => {
                if (item.uniqueCode == this.obligee) {
                    this.rightListdate.map((items) => {
                        if (items.isTrue == true) {
                            arr.push(items.type);
                        }
                    });
                    item.rightsCategoryArray = arr;
                }
            });
            arr != "" ? (this.isArr = true) : (this.isArr = false);
        },
        pushRighMan() {
            this.formShow = true
        },
        rightWayListClick(e) {
            this.form.copyrightProduceMode = e.type;
        },
        copyrightListClick(e) {
            this.form.copyrightRightsGet = e.type;
        },
    }
};
</script>
<style lang="scss">
.workOwnershipInformation .el-form-item__label {
    font-size: 12px;
}

.workOwnershipInformation .el-select {
    width: 100%;
}

.workOwnershipInformation .el-form-item__label {
    font-size: 12px;
}

.workOwnershipInformation .el-form-item {
    margin-bottom: 30px;
}

.workOwnershipInformation .el-form-item__error {
    position: static;
}
</style>
<style lang="scss" scope>
.workOwnershipInformation {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .subjectinformation {
        .container {
            width: 550px;
            padding-bottom: 100px;
            box-sizing: border-box;

            .idCardWap {
                width: 452px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .item {
                    width: 144px;
                    height: 96px;

                    .img_ {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        position: relative;
                        justify-content: center;

                        input {
                            width: 100%;
                            height: 100%;
                            display: block;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 1;
                            opacity: 0;
                        }

                        img {
                            width: 100%;
                            //   position: absolute;
                            //   top: 0;
                            //   left: 0;
                        }
                    }
                }
            }

            .expiryDateWap {
                display: flex;
                justify-content: space-between;
                align-items: center;

                div:nth-of-type(1) {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                div:nth-of-type(2) {
                    width: 250px;
                }
            }

            .selectFourWap {
                display: flex;
                justify-content: space-between;
                align-items: center;

                div {
                    width: 100px;
                }
            }
        }
    }

    .btnwap {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 40px 0;

        .btnContent {
            width: 432px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
                text-align: center;
                border-radius: 8px;
                height: 40px;
                font-size: 14px;
                font-family: AlibabaPuHuiTiM;
                line-height: 40px;
                cursor: pointer;
            }

            div:nth-of-type(1) {
                width: 120px;
                color: #909399;
                text-align: center;
                background: #fff;
                border: 1px solid #c0c4cc;
            }

            div:nth-of-type(2) {
                width: 240px;
                color: #ffffff;
                background: #008aea;
            }
        }
    }

    .rightListwap {
        width: 734px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        div {
            width: 114px;
            height: 40px;
            background: #f5f7fa;
            border-radius: 8px;
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #008aea;
            line-height: 40px;
            text-align: center;
            margin-bottom: 10px;
            cursor: pointer;
        }

        .active {
            color: #ffffff !important;
            background: #008aea !important;
        }
    }

    .authorList {
        height: 90px;
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;

        .key_ {
            width: 64px;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #303133;
            // margin-top: 8px;
        }

        .valueSet {
            width: 432px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .txtStyle {
                height: 40px;
                line-height: 40px;
                font-size: 13px;
                font-family: AlibabaPuHuiTiR;
                color: #909399;
            }

            .inputStyle {
                width: 100%;
                height: 40px;
                background: #ffffff;
                border-radius: 6px;
                border: 1px solid #cccccc;
                padding: 8px;
                box-sizing: border-box;

                input {
                    width: 100%;
                    height: 100%;
                    border: none;
                    background: none;
                    outline: none;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #909399;
                }
            }
        }
    }

    .pushAuthor {
        width: 144px;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #008aea;
        border-radius: 8px;
        cursor: pointer;
        margin: 20px 0 20px 74px;
    }

    .typeContainer {
        width: 734px;

        .formBodySet {
            display: flex;
            align-items: center;
        }

        .formBody {
            width: 432px;
        }

        .expiryDateWap {
            width: 432px;
            justify-content: space-between;
            display: flex;
            align-items: center;

            div:nth-of-type(1) {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            div:nth-of-type(2) {
                width: 250px;
            }
        }

        .idCardWap {
            width: 452px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
                width: 144px;
                height: 96px;

                .img_ {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: center;

                    input {
                        width: 100%;
                        height: 100%;
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        opacity: 0;
                    }

                    img {
                        width: 100%;
                    }
                }
            }
        }

        .listTitle {
            font-size: 18px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
            font-weight: 700;
            margin: 30px 0;

            span {
                color: #cc3f1f;
                margin-right: 3px;
            }
        }

        .obligeeWap {
            display: flex;
            align-items: center;

            .obligeeList {
                display: flex;
                align-items: center;

                .item {
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    cursor: pointer;

                    .right_ {
                        font-size: 14px;
                        font-family: AlibabaPuHuiTiM;
                        color: #606266;
                    }

                    .left_ {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 24px;

                        img {
                            width: 100%;
                        }
                    }
                }
            }

            .name {
                width: 64px;
                height: 100%;
                font-size: 12px;
                font-family: AlibabaPuHuiTiR;
                color: #303133;
            }
        }

        .successfulData {
            border-bottom: 1px #e6e6e6 solid;
            margin-bottom: 20px;

            .item {
                display: flex;
                align-items: center;
                margin: 20px 0;

                .pushAuthor {
                    width: 144px;
                    height: 40px;
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiM;
                    color: #ffffff;
                    line-height: 40px;
                    text-align: center;
                    background: #008aea;
                    border-radius: 8px;
                    cursor: pointer;
                }

                .imgList {
                    display: flex;
                    align-items: center;

                    div {
                        width: 144px;
                        height: 96px;
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 10px;
                        overflow: hidden;

                        img {
                            height: 100%;
                        }
                    }
                }

                .bodyBg {
                    width: 432px;
                    height: 40px;
                    background: #f2f2f2;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    padding: 8px;
                    box-sizing: border-box;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #909399;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    div {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .bodyNotBg {
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiM;
                    color: #606266;
                    line-height: 40px;
                }

                .title_ {
                    width: 64px;
                    font-size: 12px;
                    font-family: AlibabaPuHuiTiR;
                    color: #303133;
                    margin-right: 10px;
                }
            }
        }

        .forImgWap {
            display: flex;
            align-items: center;
            margin-top: 8px;

            .itemList {
                width: 160px;
                margin-right: 24px;

                .downloadTemplate {
                    font-size: 12px;
                    font-family: AlibabaPuHuiTiR;
                    color: #008aea;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-top: 10px;
                }

                .theTitle {
                    font-size: 12px;
                    font-family: AlibabaPuHuiTiM;
                    color: #303133;
                    margin-bottom: 8px;
                }

                .theFont {
                    margin-top: 4px;
                    width: 160px;
                    height: 48px;
                    font-size: 12px;
                    font-family: AlibabaPuHuiTiR;
                    color: #909399;
                    line-height: 16px;
                }

                .theImg {
                    width: 100%;
                    height: 240px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: center;
                    overflow: hidden;

                    input {
                        width: 100%;
                        height: 100%;
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        opacity: 0;
                    }

                    img {
                        width: 100%;
                    }
                }
            }
        }

        .introduce {
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
            margin-top: 10px;
        }

        .typelist {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            margin: 20px 0 0;

            div {
                width: 102px;
                height: 40px;
                border-radius: 8px;
                font-size: 13px;
                font-family: AlibabaPuHuiTiM;
                line-height: 40px;
                text-align: center;
                margin-bottom: 10px;
                background: #f5f7fa;
                color: #008aea;
                font-weight: 700;
                cursor: pointer;
                margin-right: 10px;
            }

            .active {
                color: #ffffff;
                background: #008aea;
            }
        }
    }
}
</style>

